module.exports = __webpack_public_path__ + "img/uploaded-docs.87855983.svg";